module.exports = __webpack_public_path__ + "img/healthtimer.0cf95adf.png";